import { toCamelCaseKeys } from '@/js/lib/helper/localize-keys';
import jsonData from './category.json';

export interface CategoryData {
  categoryId: number;
  parentCategoryId: number;
  sort: number;
  slug: string;
  name: string;
}

const categoryData: CategoryData[] = toCamelCaseKeys(jsonData);

export const categoryIdFood = categoryData.find((cat) => cat.slug === 'food')?.categoryId;

export const categoryIdAlcohol = categoryData.find((cat) => cat.slug === 'alcohol')?.categoryId;

export const categories = ({ parentCategoryId = 0 } = {}): CategoryData[] => categoryData.filter((cat) => cat.parentCategoryId === parentCategoryId).sort((a, b) => a.sort - b.sort);

export const category = ({ categoryId }: { categoryId: number }) => categoryData.find((cat) => cat.categoryId === categoryId);
